import { useState } from 'react';

import { capitalize } from 'lodash';
import { ToggleOptionGroup, ToggleOptionGroupItem } from 'twyne-new.ui';

import { HIDE_SIZES, PREDEFINED_SIZES } from '../utils/predefined_sizes';

import { PredefinedArbitraryUnit } from './PredefinedArbitraryUnit';

export default function AdvancedSizeProperty({ show }) {
  const [tab, setTab] = useState('width')

  if (!show) {
    return null
  }

  return <>
    <div className='mt-4'>Advanced Size</div>
    <ToggleOptionGroup size='lg' value={tab} type='single' onValueChange={value => value && setTab(value)}>
      <ToggleOptionGroupItem value='width'>
        Width
      </ToggleOptionGroupItem>
      <ToggleOptionGroupItem value='height'>
        Height
      </ToggleOptionGroupItem>
    </ToggleOptionGroup>

    <div key={tab} className='flex flex-col gap-1 mt-1'>
      <div className='grid grid-cols-3 gap-1 items-center'>
        <span className='col-span-1'>Max {capitalize(tab)}</span>

        <PredefinedArbitraryUnit
          name={`size.max.${tab}`}
          predefined
          predefinedOptions={PREDEFINED_SIZES[tab].filter(opt => !HIDE_SIZES[tab]?.max?.includes(opt.value))}
          className='col-span-2'
        />
      </div>

      <div className='grid grid-cols-3 gap-1 items-center'>
        <span className='col-span-1'>Min {capitalize(tab)}</span>

        <PredefinedArbitraryUnit
          name={`size.min.${tab}`}
          predefined
          predefinedOptions={PREDEFINED_SIZES[tab].filter(opt => !HIDE_SIZES[tab]?.min?.includes(opt.value))}
          className='col-span-2'
        />
      </div>
    </div>
  </>
}
